var _rect, _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoBj(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    overflow: "visible",
    viewBox: "0 0 19 18",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 0.125,
    fill: "#FFC700",
    rx: 9
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.125,
    cy: 9,
    r: 9,
    fill: "#FFC700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m9.39.818-.681.765c-.165.185-4.043 4.549-5.526 6.438a3.76 3.76 0 0 0-.768 1.75 3.4 3.4 0 0 0 .204 1.787c.417 1.026 1.325 1.765 2.488 2.027a5.5 5.5 0 0 0 2.103.049l-.394 1.197-.326.987h5.508l-.35-1-.39-1.11q.48.118.99.118c1.267 0 2.5-.553 3.22-1.445a3.43 3.43 0 0 0 .753-2.116 3.25 3.25 0 0 0-.746-2.124c-1.568-1.865-5.397-6.49-5.435-6.537z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.942 12.258h-.945v-4.68l.036-.738a4 4 0 0 1-.243.225q-.126.108-.288.252l-.702.567-.486-.612 1.836-1.44h.792zm-3.314 0h-4.32v-.738l1.656-1.683q.486-.495.81-.855.324-.369.486-.702.162-.342.162-.738 0-.495-.288-.738-.288-.252-.747-.252-.441 0-.792.17a3.7 3.7 0 0 0-.73.46l-.512-.64q.261-.224.558-.404.306-.18.675-.288.378-.108.828-.108.612 0 1.053.216.441.207.675.594.243.386.243.909 0 .513-.207.954a3.8 3.8 0 0 1-.585.873q-.379.423-.891.918l-1.197 1.16v.046h3.123z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBj);
export default __webpack_public_path__ + "static/media/IcoBJ.081b2b23c80ce018ba1f89f61ba29500.svg";
export { ForwardRef as ReactComponent };